'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { growthTourStepIndexForPathname } from '@communio/host-growth-guide';
import { NavTourBubble } from '@/platform/navTour/NavTourBubble';
import { useGrowthPathTour } from './GrowthPathTourContext';
import { growthTourAnchorSelector } from './growthTourAnchor';

/** Opt-in host path tour. Separate from the first-run sidebar tour. */
export function GrowthPathTourCoach() {
  const tour = useGrowthPathTour();
  const pathname = usePathname() || '/';
  const prevPath = useRef(pathname);

  useEffect(() => {
    if (!tour.active || tour.stepIds.length === 0) return;
    if (prevPath.current === pathname) return;
    prevPath.current = pathname;
    const idx = growthTourStepIndexForPathname(pathname, tour.stepIds);
    if (idx === null) return;
    tour.setStepIndex(idx);
  }, [pathname, tour]);

  useEffect(() => {
    if (!tour.active) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') tour.finish();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [tour]);

  if (!tour.active || !tour.step) return null;

  return (
    <NavTourBubble
      step={{
        id: tour.step.id as 'home',
        title: tour.step.title,
        body: tour.step.body,
        anchor: 'sidebar',
      }}
      stepIndex={tour.stepIndex}
      stepCount={tour.stepCount}
      onBack={tour.goBack}
      onNext={tour.goNext}
      onSkip={tour.finish}
      anchorSelector={growthTourAnchorSelector(tour.step.id)}
    />
  );
}
